import React from 'react';
import { MulticreatorPackageIndexView } from '../../../types/multicreator_packages';
import './multicreatorPackageCard.module.scss';
import { RadioButton } from '../../atoms/select/RadioCard';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { FixedPackageItemCard } from './FixedPackageItemCard';
import { SessionIndexView } from '../../../types/sessions';
import { SessionItemCard } from './SessionItemCard';
import { SessionId } from '../../../../commonv3/types/sessions';

const PaneHeader = ({ children }) => <div styleName="pane-header">{children}</div>;
const PaneDescription = ({ children }) => <div styleName="pane-description">{children}</div>;
const PaneBody = ({ children, ...props }) => (
  <div styleName="pane-body" className="pane-body" {...props}>
    {children}
  </div>
);

type Props = {
  multicreatorPackage: MulticreatorPackageIndexView;
  initialCareerCoachingSessions: SessionIndexView[];
  intermediateReviewSessions: SessionIndexView[];
  finalReviewSessions: SessionIndexView[];
  selectedInitialCoachingSessionId: SessionId | null;
  selectedIntermediateReviewSessionId: SessionId | null;
  selectedFinalReviewSessionId: SessionId | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectInitialCoachingSession: (sessionId: SessionId) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectIntermediateReviewSession: (sessionId: SessionId) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectFinalReviewSession: (sessionId: SessionId) => any;
  selected: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelect: () => any;
};

export const MulticreatorPackageCard = observer(
  ({
    multicreatorPackage,
    intermediateReviewSessions,
    finalReviewSessions,
    initialCareerCoachingSessions,
    selectedFinalReviewSessionId,
    selectedInitialCoachingSessionId,
    selectedIntermediateReviewSessionId,
    selectInitialCoachingSession,
    selectFinalReviewSession,
    selectIntermediateReviewSession,
    selected,
    onSelect,
  }: Props) => {
    return (
      <div styleName="wrapper">
        <div
          styleName="header"
          onClick={() => onSelect()}
          className="multicreator-package-card"
          data-package-id={multicreatorPackage.id}
        >
          <RadioButton checked={selected} styleName="radio" />
          <div styleName="header-inner">
            {multicreatorPackage.name}
            <div styleName="arrow" />
          </div>
        </div>
        <div styleName={classNames('body', { expanded: selected })}>
          <PaneHeader>① グループフィードバック会の日程を確認する</PaneHeader>
          <PaneDescription>
            グループフィードバック会は<strong>月2回 / 合計8回</strong>
            開催されます。下記の実施される日程をご確認ください。
          </PaneDescription>
          <PaneBody data-session-type="multicreator_group_feedback">
            {multicreatorPackage.package_items.map((item) => (
              <FixedPackageItemCard key={item.id} packageItem={item} />
            ))}
          </PaneBody>
          <PaneHeader>② 中間講評会の日程を決める</PaneHeader>
          <PaneDescription>下記の実施される日程をご確認ください。</PaneDescription>
          <PaneBody data-session-type="multicreator_intermediate_review">
            {intermediateReviewSessions.map((item) => (
              <SessionItemCard
                key={item.id}
                session={item}
                selected={selectedIntermediateReviewSessionId === item.id}
                onSelect={() => selectIntermediateReviewSession(item.id)}
              />
            ))}
          </PaneBody>
          <PaneHeader>③ 初回1on1キャリアコーチングの日程を決める</PaneHeader>
          <PaneDescription>
            1on1キャリアコーチングは<strong>月1回 / 合計4回</strong>開催されます。
            <strong>2回目以降はHOMEよりご予約ください。</strong>
          </PaneDescription>
          <PaneBody data-session-type="multicreator_initial_career_coaching">
            {initialCareerCoachingSessions.map((item) => (
              <SessionItemCard
                key={item.id}
                session={item}
                selected={selectedInitialCoachingSessionId === item.id}
                onSelect={() => selectInitialCoachingSession(item.id)}
              />
            ))}
          </PaneBody>
          <PaneHeader>④ 最終講評会の日程を決める</PaneHeader>
          <PaneDescription>
            最終講評会は最終月に1回のみ開催されます。下記の実施される日程をご確認ください。
          </PaneDescription>
          <PaneBody data-session-type="multicreator_final_review">
            {finalReviewSessions.map((item) => (
              <SessionItemCard
                key={item.id}
                session={item}
                selected={selectedFinalReviewSessionId === item.id}
                onSelect={() => selectFinalReviewSession(item.id)}
              />
            ))}
          </PaneBody>
        </div>
      </div>
    );
  }
);
